export interface AvasyaProduct {
  id: string;
  name: string;
  description: string;
  category: string;
  subCategory?: string;
  netWeight: string;
  price: number;
  image: string;
  inStock: boolean;
}

export const avasyaProducts: AvasyaProduct[] = [
  // === BREAKFAST CEREALS ===
  {
    id: 'muesli-vanilla',
    name: 'Muesli Vanilla',
    description: 'Wholesome breakfast cereal with vanilla flavor. Great source of fiber and energy.',
    category: 'Breakfast Cereals',
    subCategory: "Muesli's",
    netWeight: '100 gms',
    price: 99,
    image: '/images/avasya/muesli-vanilla.png',
    inStock: true,
  },
  {
    id: 'muesli-chocolate',
    name: 'Muesli Chocolate',
    description: 'Delicious chocolate-flavored muesli for breakfast. Great source of fiber and energy.',
    category: 'Breakfast Cereals',
    subCategory: "Muesli's",
    netWeight: '100 gms',
    price: 99,
    image: '/images/avasya/muesli-chocolate.png',
    inStock: true,
  },
  {
    id: 'rolled-flakes',
    name: 'Rolled Flakes',
    description: 'Jowar, Ragi, Bajra, Barnyard, Browntop, Little Millet, Kodo, Wheat, Barley, Brown Rice, Red Rice, Fenugreek.',
    category: 'Breakfast Cereals',
    subCategory: 'Millet & Cereal Flakes',
    netWeight: 'Various',
    price: 0,
    image: '/images/avasya/rolled-flakes.png',
    inStock: true,
  },

  // === INSTANT MIX - Breakfast mix ===
  {
    id: 'ragi-idli',
    name: 'Ragi Idli',
    description: 'Ready to cook ragi idli mix. Quick hassle-free traditional breakfast with millets.',
    category: 'Instant Mix',
    subCategory: 'Breakfast mix',
    netWeight: '200 gms',
    price: 110,
    image: '/images/avasya/ragi-idli.png',
    inStock: true,
  },
  {
    id: 'millet-poha',
    name: 'Millet Poha',
    description: 'Quick and easy millet poha mix. Quick hassle-free traditional breakfast with millets.',
    category: 'Instant Mix',
    subCategory: 'Breakfast mix',
    netWeight: '200 gms',
    price: 99,
    image: '/images/avasya/millet-poha.png',
    inStock: true,
  },
  {
    id: 'millet-pongal',
    name: 'Millet Pongal',
    description: 'Traditional pongal mix with millets. Quick hassle-free traditional breakfast with millets.',
    category: 'Instant Mix',
    subCategory: 'Breakfast mix',
    netWeight: '200 gms',
    price: 110,
    image: '/images/avasya/millet-pongal.png',
    inStock: true,
  },
  {
    id: 'multigrain-dosa',
    name: 'Multigrain Dosa',
    description: 'Ready to cook multigrain dosa mix. Quick hassle-free traditional breakfast with millets.',
    category: 'Instant Mix',
    subCategory: 'Breakfast mix',
    netWeight: '200 gms',
    price: 99,
    image: '/images/avasya/multigrain-dosa.png',
    inStock: true,
  },
  {
    id: 'millet-upma',
    name: 'Millet Upma',
    description: 'Quick and healthy millet upma mix. Quick hassle-free traditional breakfast with millets.',
    category: 'Instant Mix',
    subCategory: 'Breakfast mix',
    netWeight: '200 gms',
    price: 110,
    image: '/images/avasya/millet-upma.png',
    inStock: true,
  },
  {
    id: 'millet-khichdi',
    name: 'Millet Khichdi',
    description: 'Healthy khichdi mix with millets. Quick hassle-free traditional breakfast with millets.',
    category: 'Instant Mix',
    subCategory: 'Breakfast mix',
    netWeight: '200 gms',
    price: 110,
    image: '/images/avasya/millet-khichdi.png',
    inStock: true,
  },

  // === INSTANT MIX - Beverage Mix ===
  {
    id: 'health-mix',
    name: 'Health Mix',
    description: 'Multi-grain health mix powder. Curb your hunger, cut your excess carbs & fats.',
    category: 'Instant Mix',
    subCategory: 'Beverage Mix',
    netWeight: '250 gms',
    price: 99,
    image: '/images/avasya/health-mix.png',
    inStock: true,
  },
  {
    id: 'ragi-malt',
    name: 'Ragi Malt',
    description: 'Calcium and iron-rich traditional drink. Curb your hunger, cut your excess carbs & fats.',
    category: 'Instant Mix',
    subCategory: 'Beverage Mix',
    netWeight: '250 gms',
    price: 99,
    image: '/images/avasya/ragi-malt.png',
    inStock: true,
  },
  {
    id: 'fruit-porridge-mix',
    name: 'Fruit Porridge Mix',
    description: 'Delicious and nutritious fruit porridge mix.',
    category: 'Instant Mix',
    subCategory: 'Beverage Mix',
    netWeight: '250 gms',
    price: 99,
    image: '/images/avasya/fruit-porridge-mix.png',
    inStock: true,
  },
  {
    id: 'tomato-soup',
    name: 'Soup Tomato',
    description: 'Comforting tomato soup mix with millets.',
    category: 'Instant Mix',
    subCategory: 'Beverage Mix',
    netWeight: '100 gms',
    price: 99,
    image: '/images/avasya/tomato-soup.png',
    inStock: true,
  },
  {
    id: 'vegetable-soup',
    name: 'Soup Vegetable',
    description: 'Nutritious vegetable soup mix.',
    category: 'Instant Mix',
    subCategory: 'Beverage Mix',
    netWeight: '100 gms',
    price: 99,
    image: '/images/avasya/vegetable-soup.png',
    inStock: true,
  },
  {
    id: 'vegetable-porridge-mix',
    name: 'Vegetable Porridge Mix',
    description: 'Healthy vegetable porridge mix.',
    category: 'Instant Mix',
    subCategory: 'Beverage Mix',
    netWeight: '100 gms',
    price: 99,
    image: '/images/avasya/vegetable-porridge-mix.png',
    inStock: true,
  },

  // === SNACKS - Energy Bytes (Extruded Snacks) ===
  {
    id: 'energy-bytes-pudina',
    name: 'Energy Bytes Pudina',
    description: 'Guilt-free snacking. Boost your nutrition intake.',
    category: 'Snacks',
    subCategory: 'Energy Bytes',
    netWeight: '80 gms',
    price: 42,
    image: '/images/avasya/enerygy-bytes-pudina.png',
    inStock: true,
  },
  {
    id: 'energy-bytes-cheese-chilli',
    name: 'Energy Bytes Cheese Chilli',
    description: 'Cheese and chilli flavored extruded snack. Guilt-free snacking.',
    category: 'Snacks',
    subCategory: 'Energy Bytes',
    netWeight: '80 gms',
    price: 42,
    image: '/images/avasya/enerygy-bytes-cheese-chilli.png',
    inStock: true,
  },
  {
    id: 'energy-bytes-tomato-chilli',
    name: 'Energy Bytes Tomato Chilli',
    description: 'Tomato and chilli flavored extruded snack. Guilt-free snacking.',
    category: 'Snacks',
    subCategory: 'Energy Bytes',
    netWeight: '80 gms',
    price: 42,
    image: '/images/avasya/enerygy-bytes-tomato-chilli.png',
    inStock: true,
  },
  {
    id: 'energy-bytes-tangy-tomato',
    name: 'Energy Bytes Tangy Tomato',
    description: 'Tangy tomato flavored extruded snack. Guilt-free snacking.',
    category: 'Snacks',
    subCategory: 'Energy Bytes',
    netWeight: '80 gms',
    price: 42,
    image: '/images/avasya/energy-bytes-tangy-tomato.png',
    inStock: true,
  },
  {
    id: 'energy-bytes-masala',
    name: 'Energy Bytes Masala',
    description: 'Spicy masala flavored extruded snack. Guilt-free snacking.',
    category: 'Snacks',
    subCategory: 'Energy Bytes',
    netWeight: '80 gms',
    price: 42,
    image: '/images/avasya/energy-bytes-masala.png',
    inStock: true,
  },

  // === SPICE POWDERS ===
  {
    id: 'nalla-karam',
    name: 'Nalla Karam',
    description: 'Not just for taste & colour. Boost your immunity.',
    category: 'Spice Powders',
    netWeight: '100 gms',
    price: 55,
    image: '/images/avasya/nallakaram-powder.png',
    inStock: true,
  },
  {
    id: 'coriander-spice-powder',
    name: 'Coriander Spice Powder',
    description: 'Pure coriander spice powder. Boost your immunity.',
    category: 'Spice Powders',
    netWeight: '100 gms',
    price: 55,
    image: '/images/avasya/coriander-spice-powder.png',
    inStock: true,
  },
  {
    id: 'roasted-chana-powder',
    name: 'Roasted Chana Powder',
    description: 'Nutritious roasted chana powder. Boost your immunity.',
    category: 'Spice Powders',
    netWeight: '100 gms',
    price: 55,
    image: '/images/avasya/roasted-chana.png',
    inStock: true,
  },
  {
    id: 'curry-leaves-spice-powder',
    name: 'Curry Leaves Spice Powder',
    description: 'Aromatic curry leaves powder. Boost your immunity.',
    category: 'Spice Powders',
    netWeight: '100 gms',
    price: 55,
    image: '/images/avasya/curry-leaves.png',
    inStock: true,
  },
  {
    id: 'curry-powder',
    name: 'Curry Powder',
    description: 'Balanced curry powder blend. Boost your immunity.',
    category: 'Spice Powders',
    netWeight: '100 gms',
    price: 55,
    image: '/images/avasya/curry-powder.png',
    inStock: true,
  },
  {
    id: 'sambar-powder',
    name: 'Sambar Powder',
    description: 'Traditional sambar powder. Boost your immunity.',
    category: 'Spice Powders',
    netWeight: '100 gms',
    price: 60,
    image: '/images/avasya/sambar-powder.png',
    inStock: true,
  },
  {
    id: 'rasam-powder',
    name: 'Rasam Powder',
    description: 'Tangy rasam powder. Boost your immunity.',
    category: 'Spice Powders',
    netWeight: '100 gms',
    price: 60,
    image: '/images/avasya/rasam-powder.png',
    inStock: true,
  },

  // === FLOURS AND GRITS ===
  {
    id: 'flours-grits',
    name: 'Flours & Grits',
    description: 'Jowar, Ragi, Bajra, Barnyard, Browntop, Little Millet, Kodo, Foxtail, Multigrain. Make your preparations healthy with whole flours & whole grits.',
    category: 'Flours And Grits',
    netWeight: 'Various',
    price: 0,
    image: '/images/avasya/flours-grits.png',
    inStock: true,
  },
];

export const avasyaCategories = [
  'Breakfast Cereals',
  'Instant Mix',
  'Snacks',
  'Spice Powders',
  'Flours And Grits',
];
